module.exports = __webpack_public_path__ + "static/media/DrStrair.1726dc8d.png";